"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherInfoSchema = void 0;
var zod_1 = require("zod");
exports.OtherInfoSchema = zod_1.z.object({
    SRB: zod_1.z.string().optional(),
    CWB: zod_1.z.string().optional(),
    TRB: zod_1.z.string().optional(),
    OtherQualifications: zod_1.z.string().optional(),
    Experience: zod_1.z.string().optional(),
    AreaOfOperations: zod_1.z.string().optional(),
    CurrentBusiness: zod_1.z.string().optional(),
    JobTitle: zod_1.z.string().optional(),
    TypeOfBusiness: zod_1.z.array(zod_1.z.string()).optional(),
    Position: zod_1.z.string().optional(),
});
//# sourceMappingURL=OtherInfo.js.map